"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralsControllerMyRewardsV1200Response = instanceOfReferralsControllerMyRewardsV1200Response;
exports.ReferralsControllerMyRewardsV1200ResponseFromJSON = ReferralsControllerMyRewardsV1200ResponseFromJSON;
exports.ReferralsControllerMyRewardsV1200ResponseFromJSONTyped = ReferralsControllerMyRewardsV1200ResponseFromJSONTyped;
exports.ReferralsControllerMyRewardsV1200ResponseToJSON = ReferralsControllerMyRewardsV1200ResponseToJSON;
exports.ReferralsControllerMyRewardsV1200ResponseToJSONTyped = ReferralsControllerMyRewardsV1200ResponseToJSONTyped;
var ReferralRewardItemDto_1 = require("./ReferralRewardItemDto");
/**
 * Check if a given object implements the ReferralsControllerMyRewardsV1200Response interface.
 */
function instanceOfReferralsControllerMyRewardsV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ReferralsControllerMyRewardsV1200ResponseFromJSON(json) {
    return ReferralsControllerMyRewardsV1200ResponseFromJSONTyped(json, false);
}
function ReferralsControllerMyRewardsV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(ReferralRewardItemDto_1.ReferralRewardItemDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function ReferralsControllerMyRewardsV1200ResponseToJSON(json) {
    return ReferralsControllerMyRewardsV1200ResponseToJSONTyped(json, false);
}
function ReferralsControllerMyRewardsV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(ReferralRewardItemDto_1.ReferralRewardItemDtoToJSON)),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
